import React, { Component } from "react";
import PropTypes from 'prop-types';
import TimeItem from "../components/TimeItem";
import "./styles/personalInformation.css";

import { connect } from 'react-redux';
import { getTimeline } from '../redux/actions/dataActions';

class personalInformation extends Component {
  state = {
    values: null,
  };

  componentDidMount() {
    this.props.getTimeline();
  }

  render() {

    const { data: { time } } = this.props

    let timeMarkups = time ? (
       time.map((time) => <TimeItem time={time} />)
    ) : (
      <p>Loading...</p>
    );

    return (
      <div className="personalInformation">
        <h1>Personal Information</h1>
        <div className="timeline">
            {timeMarkups}
        </div>
      </div>
    );
  }
}

personalInformation.propTypes = {
  classes: PropTypes.object.isRequired,
  getTimeline: PropTypes.func.isRequired,
  data: PropTypes.object.isRequired
}

const mapStateToProps = (state) => ({
  data: state.data
});

const mapActionsToProps = {
  getTimeline
}

export default connect(mapStateToProps, mapActionsToProps)(personalInformation);
